// Modal.js
import React from 'react';
//import './Modal.css'; // Optional: for styling

const Message = ({ isOpen, onClose, type, children }) => {
  if (!isOpen) return null;

  const renderContent = () => {
    switch (type) {
      case 'info':
        return <div className='col-12 modal-content'>
                    <div className='col-12 navbar-default'>
                        <div className='col-3'><h4>Info Modal</h4></div> 
                        <div className='col-8'></div> 
                        <div className='col-1'><button onClick={onClose}>&times;</button></div>
                    </div>
                    <div className='col-12 popup-container'>{children}</div>
                </div>;
      case 'warning':
        return <div className='col-12 modal-content'>
                    <div className='col-12 alert alert-danger'>
                        <div className='col-1'><span className="glyphicon glyphicon-exclamation-sign" /></div>
                        <div className='col-4'><h4>Warning Modal</h4></div> 
                        <div className='col-6'></div> 
                        <div className='col-1'><button onClick={onClose}>&times;</button></div>
                    </div>
                    <div className='col-12 popup-container'>{children}</div>
                </div>;
      case 'success':
        return <div className='col-12 modal-content'>
                    <div className='col-12 navbar-default'>
                        <div className='col-3'><h4>Succes Modal</h4></div> 
                        <div className='col-8'></div> 
                        <div className='col-1'><button onClick={onClose}>&times;</button></div>
                    </div>
                    <div className='col-12 popup-container'>{children}</div>
                </div>;
      default:
        return <div className='col-12 modal-content'>
                    <div className='col-12 navbar-default'>
                        <div className='col-5'><h4>Default Modal</h4></div> 
                        <div className='col-6'></div> 
                        <div className='col-1'><button onClick={onClose}>&times;</button></div>
                    </div>
                    <div className='col-12 popup-container'>{children}</div>
                </div>;
    }
  };

  return (
    <div className="modal-overlay">
      {renderContent()}
    </div>
  );
};

export default Message;